import { setContextualSupportVisibility, setListingTransformType } from 'js/actions';
import { ReusableTransformDescription } from 'js/components/reusableTransforms/ReusableTransformBannerActions/ReusableTransformDescription';
import { isFinite } from 'lodash';
import { TransformType } from 'new/components/ReusableTransform/types';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ExclusiveButtons } from 'new/elements/ExclusiveButtons';
import { ReactComponent as PlusIcon } from 'new/components/icons/fi-rr-plus.svg';
import { Button } from 'new/elements/support/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './ReusableTransformBannerActions.scss';

type Props = {
  transformID?: number;
  onSubmit(type?: string): void;
};

const transformTypeOptions = [
  {
    label: 'Attribute Transforms',
    value: TransformType.ATTRIBUTE,
  },
  {
    label: 'Record Transforms',
    value: TransformType.RECORD,
  },
  {
    label: 'Connector Processors',
    value: TransformType.CUSTOM,
  },
];

const buttonLabelByType = {
  [TransformType.ATTRIBUTE]: 'New Attribute Transform',
  [TransformType.RECORD]: 'New Record Transform',
  [TransformType.CUSTOM]: 'New Connector Processor',
};

function ReusableTransformBannerActions({ transformID, onSubmit }: Props) {
  const dispatch = useDispatch();
  const {
    transforms: { listingTransformType },
  } = useSelector((state: any) => state);
  const singleItemMode = isFinite(transformID);

  function openSupportModal() {
    dispatch(setContextualSupportVisibility(true));
  }

  function handleOnSubmit() {
    if (singleItemMode) return;
    if (typeof onSubmit === 'function') {
      onSubmit(listingTransformType);
    }
  }

  function handleOnChangeType(event: any, value: any) {
    dispatch(setListingTransformType(value));
  }

  return (
    <BannerDescription
      title="Reusable Transforms"
      description={<ReusableTransformDescription openSupportModal={openSupportModal} />}
    >
      <div className="reusable-transform-banner-actions-container">
        <ExclusiveButtons
          data={transformTypeOptions}
          value={listingTransformType}
          onChange={handleOnChangeType}
        />
        <div className="transform-create-a-new-one">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleOnSubmit}
            startIcon={<PlusIcon />}
          >
            {buttonLabelByType[listingTransformType]}
          </Button>
        </div>
      </div>
    </BannerDescription>
  );
}

export default ReusableTransformBannerActions;
